<template>
  <div class="total_content">
    <div class="tool_title">{{toolTitle}}</div>
    <div class="tools_content">
      <div class="tools_info">
        <div class="tools_item" v-for="(item, index) in tools" :key="index">
          <div class="tools_item_img"><img :src="item.icon" alt=""></div>
          <div class="tools_item_text" @click="itemClick(index)">{{item.name}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "siteTools",
    methods: {
      itemClick(index){
        window.open(this.tools[index].hrefSelf)
      }
    },
    props:{
      // 工具标题
      toolTitle: {
        type: String,
        required: true,
      },
      // 站外链接
      tools: {
        type: Array,
        required: true,
      }
    }
  }
</script>

<style scoped>
  .total_content{
    background-color: white;
  }

  .tool_title{
    width: 100%;
    border-bottom: 1px solid rgba(241, 244, 249, 1);
    font-weight: 600;
    color: black;
    text-align: start;
  }

  .tool_title:after{
    content:'';
    display: block;
    border-bottom:3px solid #ff7f17;
  }

  .tools_content{
    display: inline-block;
    justify-content: center;
  }

  .tools_info{
    display: flex;
    flex-wrap: wrap;
  }

  .tools_item{
    vertical-align:middle;
    display: flex;
  }

  .tools_item_img img{
    height: auto;
  }

  .tools_item_text{
    font-weight: 400;
    color: black;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .tools_item_text:hover{
    color: #19acfd;
    cursor: pointer;
  }

  @media screen and (max-width: 1422px) {
    .total_content{
      width: 35rem;
      height: 28rem;
      border-radius: 1.4rem;
      margin: 1rem;
    }

    .tool_title{
      font-size: 1.8rem;
      padding: 1rem 1rem 0;
      height: 3.8rem;
    }

    .tool_title:after{
      width: 1.8rem;
      margin-left: 3.8rem;
    }

    .tools_content{
      margin: 1rem 0 2rem 1rem;
    }

    .tools_info{
      margin: 0.2rem 0;
    }

    .tools_item{
      height: 2rem;
      line-height: 2rem;
      margin: 0.6rem 0.1rem 0.6rem 0.1rem;
    }

    .tools_item_img img{
      width: 1.8rem;
    }

    .tools_item_text{
      width: 9rem;
      font-size: 0.5rem;
    }
  }

  @media screen and (max-width: 1600px) and (min-width: 1422px) {
    .total_content{
      width: 35.3rem;
      height: 28rem;
      border-radius: 1.4rem;
      margin: 1rem;
    }

    .tool_title{
      font-size: 1.8rem;
      padding: 1rem 1rem 0;
      height: 3.8rem;
    }

    .tool_title:after{
      width: 1.8rem;
      margin-left: 3.8rem;
    }

    .tools_content{
      margin: 1rem 0 2rem 1rem;
    }

    .tools_info{
      margin: 0.2rem 0;
    }

    .tools_item{
      height: 2rem;
      line-height: 2rem;
      margin: 0.6rem 0.1rem 0.6rem 0.1rem;
    }

    .tools_item_img img{
      width: 1.8rem;
    }

    .tools_item_text{
      width: 9rem;
      font-size: 0.5rem;
    }
  }

  @media screen and (min-width: 1600px){
    .total_content{
      width: 480px;
      height: 300px;
      border-radius: 10px;
      margin: 10px 13px;
    }

    .tool_title{
      font-size: 20px;
      padding: 12px 10px 0;
      height: 40px;
    }

    .tool_title:after{
      width: 20px;
      margin-left: 40px;
    }

    .tools_content{
      margin: 10px 0 20px 0;
    }

    .tools_info{
      margin: 2px 10px;
    }

    .tools_item{
      height: 22px;
      line-height: 22px;
      margin: 6px;
    }

    .tools_item_img img{
      width: 20px;
    }

    .tools_item_text{
      width: 120px;
      font-size: 14px;
    }
  }
</style>
